import {
  CommandBar,
  ICommandBarItemProps,
  ICommandBarStyles,
} from "@fluentui/react/lib/CommandBar";
import { PanelMode } from "../types";

interface CredentialsCommandBarProps {
  hasSelection: boolean;
  onCreate: (mode: PanelMode) => void;
  onRefresh: () => void;
  onDelete: (show: boolean) => void;
}

export const CredentialsCommandBar = ({
  hasSelection,
  onCreate,
  onRefresh,
  onDelete,
}: CredentialsCommandBarProps) => {
  const items: ICommandBarItemProps[] = [
    {
      key: "new-credential",
      text: "Create ingestion source",
      iconProps: { iconName: "Add" },
      ariaLabel: "Create ingestion source",
      onClick: () => onCreate("create"),
    },
    {
      key: "edit-credential",
      text: "Edit",
      iconProps: { iconName: "Edit" },
      disabled: !hasSelection,
      ariaLabel: "Edit selected credential",
      onClick: () => onCreate("update"),
    },
    {
      key: "refresh",
      text: "Refresh",
      iconProps: { iconName: "Refresh" },
      ariaLabel: "Refresh list of credentials",
      onClick: onRefresh,
    },
    {
      key: "delete-credential",
      text: "Delete",
      iconProps: { iconName: "Delete" },
      disabled: !hasSelection,
      ariaLabel: "Delete selected credential",
      onClick: () => onDelete(true),
    },
  ];

  return (
    <CommandBar styles={barStyles} items={items} data-cy="catalog-command-bar" />
  );
};

const barStyles: ICommandBarStyles = {
  root: {
    paddingLeft: 0,
  },
};
